<template>
  <AppNavigation/>
  <router-view/>
</template>

<script>
import AppNavigation from './components/Navigation/AppNavigation'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import { registerDropdownAutofill } from './store/helpers/binding'
import { USERLOGIN, USERLOGOUT } from './store/modules/authentication';
import { mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    AppNavigation,
  },
  methods: {
    ...mapActions([
      USERLOGIN,
      USERLOGOUT,
    ]),
    yourCallBackFunction( event ) {
      console.log("back button pressed!", event)
    },
  },
  created() {
    document.title = "RaidRoster"

    // Register to Vuex mutations so we can auto-fill the dropdowns based on latest visit
    this.unsubscribe = this.$store.subscribe( ( mutation, state ) => {
      registerDropdownAutofill( this.$store, state, mutation )
    })

    firebase.auth().setPersistence( firebase.auth.Auth.Persistence.LOCAL )

    firebase.auth().onAuthStateChanged( ( user ) => {
      // console.log( 'onAuthStateChanged', user )
      if( user ) {
        this.USERLOGIN( user )
      }
      else {
        this.USERLOGOUT()
      }
    })

  },
  mounted() {
    document.addEventListener("backbutton", this.yourCallBackFunction, false);
  },
  beforeUnmount() {
    this.unsubscribe()
    document.removeEventListener("backbutton", this.yourCallBackFunction);
  },
};
</script>

<style>
body {
  background-color: #202225;
  padding-top: 45px; /* because of the nav bar of 45px high */
  margin: 0px;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--main-font-color);
  font-size: 16px;
}
p {
  color: var(--alt2-font-color);
  font-size: 14px;
}

:root {
  --header-font-color: rgb(220, 221, 222);
  --main-font-color: rgb(194, 197, 204);
  --alt-font-color: rgb(185, 187, 190);
  --alt2-font-color: rgb(165, 167, 169);

  --main-border-color: rgb( 102, 105, 112 );

  --toolbar-bg-color: rgb(24, 25, 28);
  --main-bg-color: rgb(32, 34, 37);
  --bg1-color: rgb(47, 49, 54);
  --bg2-color: rgb(54, 57, 63);
  --bg3-color: rgb(61, 65, 72);

  --button-color: rgb(49, 118, 254);
  --button2-color: rgb(42, 101, 219);
  --hover-color: rgb(49, 145, 254);
  --highlight-number-color: #15f5ea;
  --disabled-button-color: rgb(62, 65, 68);

  --absence-color:     #adadad;
  --deathknight-color: #c41e3a;
  --demonhunter-color: #a330c9;
  --druid-color:       #ff7c0a;
  --hunter-color:      #aad372;
  --mage-color:        #3fc7eb;
  --monk-color:        #00ff98;
  --paladin-color:     #f38cba;
  --priest-color:      #ffffff;
  --rogue-color:       #fff468;
  --shaman-color:      #0070dd;
  --warlock-color:     #8788ee;
  --warrior-color:     #c69b6d;

}

.constraintviolation {
  color: rgb(255, 64, 64);
}
.checkpassed {
  color: rgb(64, 255, 64);
}
.dialogp {
  text-align: center;
  margin-bottom: 0px;
}

a {
  color: rgb(56, 150, 243);
}
a:visited {
  color: rgb(156, 84, 224);
}

.clickable:hover {
  color: var(--hover-color);
  cursor: default;
}

.backbutton {
  color: grey;
  background-color: transparent;
  border: 0px;
}
.backbutton:hover {
  color: lightgrey;
}

.corebutton {
  color: rgb(255, 245, 251);
  font-weight: bold;
  background-color: var(--button2-color);
  border: 0.0625em solid var(--button2-color);
  border-radius: 0.25em;
  padding: 0.625em 1.875em;
}
.corebutton:hover {
  color: rgb(255, 244, 239);
  background-color: var(--hover-color);
  border: 0.0625em solid var(--hover-color);
}
.corebutton:disabled {
  color: var(--bg3-color);
  background-color: var(--bg1-color);
  border: 0.0625em solid var(--bg1-color);
}

.cancelbutton {
  color: var(--main-font-color);
  font-weight: bold;
  background-color: transparent;
  border: 0.0625em solid var(--main-font-color);
  border-radius: 0.25em;
  padding: 0.625em 1.875em;
}
.cancelbutton:hover {
  color: var(--main-font-color);
  background-color: var(--bg3-color);
}

.exportbutton {
  /* color: rgb(56, 150, 243); */
  color: var(--button2-color);
  margin: 0.25em;
}

.bigbutton {
  font-weight: bold;
  border: 0px;
  border-radius: 0.625em;
  padding: 1.875em;
}
.bigbutton:hover {
  background-color: lightgrey;
}

.mediumbutton {
  font-weight: bold;
  border: 0px;
  border-radius: 0.625em;
  padding: 1.25em;
}
.mediumbutton:hover {
  background-color: lightgrey;
}

.settingsgrid {
  display: grid;
  grid-template-columns: auto auto;
  row-gap: 0.625em;
  column-gap: 0.625em;
  justify-items: left;
  align-items: center;
  justify-content: center;
}
.settinglabel {
  justify-self: right;
}

.resetbutton {
  font-size: 20px;
  margin-left: 0.25em;
  /* color: rgb(231, 78, 78); */
}

.iconpreview {
  font-size: 36px;
}

.textarea {
  font-size: 1em;
  background-color: var(--bg1-color);
  border-color: var(--bg3-color);
  color: var(--main-font-color);
  outline: none;
  border: 0.125em solid var(--bg3-color);
  border-radius: 0.25em;
}
.w200 {
  width: 200px;
}
.textarea:focus {
  border-color: var(--alt-font-color);
}
.textarea:disabled {
  color: rgb(75, 75, 75);
}

.colorinput {
  background-color: var(--bg1-color);
  border-color: var(--bg3-color);
}
.colorinput:focus {
  background-color: var(--bg1-color);
  border-color: var(--alt-font-color);
}

.debugblue {
  background-color: darkblue;
}
.debugred {
  background-color: darkred;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/* Track */
::-webkit-scrollbar-track {
  /* background: #f1f1f1; */
  background: var(--toolbar-bg-color);
  /* border-radius: 4px; */
}
/* Corner */
::-webkit-scrollbar-corner {
  background: var(--toolbar-bg-color);
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--bg3-color);
  border-radius: 4px;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(71, 75, 82);
}



/* this is for hiding unskinnable spinner buttons*/
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type=number] { 
  -moz-appearance: textfield;
  appearance: textfield;
  margin: 0; 
}</style>
